import { useTranslation } from 'react-i18next';
import { useAccounts } from '../../hooks/useAccounts';

interface AccountSelectorProps {
  value: string;
  onChange: (value: string) => void;
}

export default function AccountSelector({
  value,
  onChange,
}: AccountSelectorProps) {
  const { t } = useTranslation();
  const { data: accounts, isLoading } = useAccounts();

  if (isLoading) {
    return (
      <div className="h-10 w-48 animate-pulse rounded-md bg-gray-200" />
    );
  }

  if (!accounts || accounts.length === 0) {
    return (
      <div className="text-sm text-gray-500">
        {t('accounts.addAccount')}
      </div>
    );
  }

  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="rounded-md border border-gray-300 bg-white px-3 py-2 text-sm shadow-sm focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary"
    >
      <option value="">{t('accounts.allAccounts')}</option>
      {accounts.map((account) => (
        <option key={account._id} value={account._id}>
          {account.name} ({account.platform})
        </option>
      ))}
    </select>
  );
}
